export default __webpack_public_path__ + "static/media/exod-sidebar.b2dac8e6.jpg";